<template>
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <Card>
                <div class="card-list-heading">
                    <h2 class="text-bold">{{ __('Release') }}</h2>

                    <div class="d-flex flex-wrap">
                        <!-- <button
                            @click="submitRelease"
                            class="btn btn-md btn-primary mr-3"
                            v-if="release.id"
                        >
                            {{ __('Submit') }}
                        </button> -->

                        <RequestButton
                            :on-click="saveRelease"
                            class="btn btn-md btn-primary mr-3"
                        >
                            {{ __('Save') }}
                        </RequestButton>

                        <button
                            @click="cancel"
                            class="btn btn-md btn-primary"
                        >
                            {{ __('Cancel') }}
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class=" form-row-flex">
                            <span>
                                {{ __('Date of receipt') }}
                            </span>
                            <DateTimePicker
                                :placeholder="__('Select date')"
                                @change="formatDateOfReceipt"
                                format="YYYY-MM-DD"
                                name="release_receipt_date"
                                type="date"
                                v-model="release.date"
                                :min-date="currDate"
                                v-validate="'required'"
                                value-type="format"
                            />
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Invoice No') }}
                            </span>
                            <FormInput
                                name="release_invoice"
                                type="text"
                                v-model="release.invoice"
                                v-validate="'required'"
                            ></FormInput>
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('New recipient title') }}
                            </span>
                            
                                    <Autocomplete
                                        :fetch-callback="$api.autocomplete.releaseDocumentsNewReceivers"
                                        :placeholder="__('Select new recipient')"
                                        @input="(item) => {
                                          release.receiverTitle = item.label 
                                         release.receiverCompanyCode = item.id}"
                                        @selected="(item) =>  {
                                          release.receiverTitle = item.label
                                         release.receiverCompanyCode = item.id}"
                                        value-selector="label"   
                                >
                                <!-- v-validate="'required'" -->
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            <!-- <FormInput
                                name="release_receiver_title"
                                type="text"
                                v-model="release.receiverTitle"
                                v-validate="'required'"
                            ></FormInput> -->
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('New recipient company code') }}
                            </span>
                            <FormInput
                                name="release_receiver_company_code"
                                type="text"
                                v-model="release.receiverCompanyCode"
                                v-validate="'required'"
                            ></FormInput>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class=" form-row-flex">
                            <span>
                                {{ __('Status') }}
                            </span>
                            <FormInput
                                :value="releaseDocumentState()"
                                disabled
                                name="release_state"
                            ></FormInput>
                        </div>                    

                        <div class="form-row-flex">
                            <span>
                                {{ __('Payer title') }}
                            </span>
                              <Autocomplete
                                        :fetch-callback="$api.autocomplete.releaseDocumentsNewReceivers"
                                        :placeholder="__('Select payer')"
                                        @input="(item) => {
                                          release.payerTitle = item.label 
                                         release.payerCompanyCode = item.id}"
                                        @selected="(item) =>  {
                                          release.payerTitle = item.label
                                         release.payerCompanyCode = item.id}"
                                        value-selector="label"     >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                                  <!-- v-validate="'required'"  -->
                            <!-- <FormInput
                                name="release_payer_title"
                                type="text"
                                v-model="release.payerTitle"
                                v-validate="'required'"
                            /> -->
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Payer company code') }}
                            </span>
                            <FormInput
                                name="release_payer_company_code"
                                type="text"
                                v-model="release.payerCompanyCode"
                                v-validate="'required'"
                            />
                        </div>

                        <div class="form-row-flex">
                            <span>
                                {{ __('Payment date') }}
                            </span>
                            <DateTimePicker
                                :placeholder="__('Select date')"
                                @change="formatDatePayerPayment"
                                format="YYYY-MM-DD"
                                name="payer_payment_date"
                                type="date"
                                :min-date="currDate"
                                v-model="release.paymentDate"
                                value-type="format"
                            />
                        </div>
                    </div>
                </div>

                <ShipmentsForm :shipments="release.shipments" shipmentType="release"/>

            </Card>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Release from '../../models/Release'
import RequestButton from '../../plugins/RequestButton'
import { $api } from '../../services/api'
import { __ } from '../../translations/localization'
import ShipmentsForm from './ShipmentsForm'

export default {
  name: 'ReleaseHandle',

  components: { ShipmentsForm, RequestButton },

  beforeRouteEnter (to, from, next) {
    if (!to.params.id) {
      next((vm) => {
        vm.$nextTick(() => vm.$validator.reset())
        vm.release = new Release({date:new Date()})
      })
    } else {
      $api.releases.item(to.params.id).then((release) => {
        next((vm) => {
          vm.release = new Release(release.data)
        })
      })
    }
  },

  created () {
    $api.autocomplete.releaseDocumentsStates().then((res) => {
      this.documentStates = res.data[0]
    })
  },

  data () {
    return {
      release: new Release({}),
      documentStates: [],
      currDate: moment().format('YYYY-MM-DD')
    }
  },

  methods: {
    releaseDocumentState () {
      this.release.state = this.documentStates.label
      return this.release.state
    },

    formatDateOfReceipt (date) {
      this.release.date = moment(date).format('YYYY-MM-DD')
      return this.release.date
    },

    formatDatePaymentStart (date) {
      this.release.paymentStartDate = moment(date).format('YYYY-MM-DD')
      return this.release.paymentStartDate
    },

    formatDatePayerPayment (date) {
      this.release.paymentDate = moment(date).format('YYYY-MM-DD')
      return this.release.paymentDate
    },

    submitRelease () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          this.$modal.confirm(
            __('Are you sure want to submit this release?'),
            () => {
              return this.$api.releases.submit(this.release.id)
                .then((data) => {
                  this.$toaster.success(__('The release was successfully submitted!'))
                  this.$router.push('/release/'+data.id+'/edit')
                })
            })
        }
      })
    },

    saveRelease () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.release.id) {
            return this.$api.releases.update(this.release.id, this.release)
              .then(() => {
                this.$toaster.success(__('The release was successfully updated!'))
                this.$router.push('/release/'+this.release.id+'/edit')
              })
          }

          return this.$api.releases.create(this.release)
            .then((data) => {
              this.$toaster.success(__('The release was successfully created!'))
              this.$router.push('/release/'+data.id+'/edit')
            })
        }
      })
    },

    cancel () {
      this.$modal.confirm(
        __('Are you sure want to cancel this release?'),
        () => {
          this.$router.push('/')
        }
      )
    }
  }
}
</script>
